import { NgModule } from '@angular/core';
import { Route, RouteReuseStrategy, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { customAnimation } from 'apps/mobile/src/app/custom-animation';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApiModule,
  Configuration,
  ConfigurationParameters,
} from '@arkius/shared-api';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ToastrModule } from 'ngx-toastr';
import { Storage } from '@constants/storage';
import { JsonLoaderService } from '@services/jsonloader.service';
import { TokenInterceptor } from '@interceptors/token.interceptor';
import { StorageService } from '@services/storage.service';
import { SessionService } from '@services/session.service';
import { ResponsiveService } from '@services/responsive.service';
import { AppRoutingModule } from './app-routing.module';
import { notEnoughPointsInterceptor } from '@arkius/shared-components';
import { environment } from '@shared-envs';

export const appRoutes: Route[] = [];

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.baseUrl,
    credentials: {
      Bearer: () => `Bearer ${localStorage.getItem(Storage.SESSION_TOKEN)}`,
    },
  };
  return new Configuration(params);
}
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({
      navAnimation: customAnimation,
      scrollAssist: true,
      scrollPadding: true,
    }),
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    InlineSVGModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    ToastrModule.forRoot(),
    ApiModule.forRoot(apiConfigFactory),
  ],
  bootstrap: [AppComponent],
  providers: [
    JsonLoaderService,
    ResponsiveService,
    SessionService,
    StorageService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([notEnoughPointsInterceptor]),
    ),
  ],
})
export class AppModule {}
